import { b2bEn } from "./b2b";
const en = {
  brand: {
    name: "Inner Compass",
    tagline: "A warm, private space for your inner weather.",
    subtitle: "Companion • Reflection • Care",
  },
  common: {
    email: "Email",
    password: "Password",
    name: "Name",
    submit: "Submit",
    save: "Save",
    saving: "Saving…",
    saved: "Saved",
    cancel: "Cancel",
    confirm: "Confirm",
    delete: "Delete",
    edit: "Edit",
    add: "Add",
    close: "Close",
    back: "Back",
    next: "Next",
    continue: "Continue",
    loading: "Loading…",
    search: "Search",
    filter: "Filter",
    all: "All",
    yes: "Yes",
    no: "No",
    open: "Open",
    view: "View",
    empty: "Nothing here yet.",
    error: "Something went wrong.",
    retry: "Try again",
    optional: "optional",
    required: "required",
    signOut: "Sign out",
    settings: "Settings",
    language: "Language",
    english: "English",
    dutch: "Nederlands",
    theme: "Theme",
    light: "Light",
    dark: "Dark",
    system: "System",
    date: "Date",
    status: "Status",
    role: "Role",
    actions: "Actions",
    export: "Export",
    approve: "Approve",
    reject: "Reject",
    revoke: "Revoke",
    restore: "Restore",
    archive: "Archive",
    resend: "Resend",
    generate: "Generate",
    send: "Send",
  },
  auth: {
    signIn: "Sign in",
    signUp: "Create account",
    continueWithGoogle: "Continue with Google",
    orContinueWith: "or continue with email",
    welcomeBack: "Welcome back",
    welcomeSub: "Sign in to continue your journey.",
    newHere: "New to Inner Compass?",
    haveAccount: "Already have an account?",
    forgot: "Forgot password?",
    forgotTitle: "Forgot your password",
    forgotSub: "We'll send you a reset link if the email matches an account.",
    resetTitle: "Set a new password",
    resetSub: "Choose a strong password you'll remember.",
    inviteTitle: "You're invited",
    inviteSub: "Set your details to accept this invitation.",
    requestTitle: "Request access",
    requestSub: "Inner Compass is invite-only. Tell us a little about you and we'll be in touch.",
    createAccount: "Create your account",
    createSub: "Create your free personal account. Have an organisation invite? Add the code.",
    passwordHint: "At least 10 characters.",
    linkSent: "If the email exists, a link is on its way.",
    resetOk: "Password reset. You can sign in now.",
    acceptInvite: "Accept an invitation",
    inviteToken: "Invite token",
    haveInvite: "Have an invite code?",
    or: "or",
    requestAccess: "Request access",
    orgName: "Organisation",
    reason: "Why do you want access?",
    submitted: "Thank you — we'll review and get back to you.",
    inviteRedeemed: "Invitation accepted. Welcome.",
  },
  nav: {
    home: "Home",
    companion: "Companion",
    checkins: "Check-ins",
    plan: "Plan",
    insights: "Insights",
    rhythm: "Rhythm",
    victories: "Victories",
    memories: "Memories",
    safety: "Safety",
    settings: "Settings",
    // Admin
    admin: "Admin",
    overview: "Overview",
    users: "Users",
    conversations: "Conversations",
    flagged: "Flagged",
    invites: "Invites",
    beta: "Beta",
    usage: "Usage",
    feedback: "Feedback",
    // Platform / HR
    business: "Business",
    organisation: "Organisation",
    people: "People",
    teams: "Teams",
    locations: "Locations",
    departments: "Departments",
    analytics: "Analytics",
    wellbeing: "Wellbeing",
    audit: "Audit",
    // Care
    care: "Care",
    clients: "Clients",
    alerts: "Alerts",
    dossier: "Dossier",
    reports: "Reports",
  },
  modes: {
    business: "Business",
    care: "Care",
    modeSwitch: "Mode",
  },
  client: {
    greeting: "How's your weather today?",
    startCompanion: "Start a conversation",
    quickCheckin: "Quick check-in",
    keepGoing: "Keep going",
    todayFocus: "Today's focus",
    recentVictories: "Recent victories",
    yourPlan: "Your plan",
    weeklyInsight: "Weekly insight",
    typeMessage: "Type a message…",
    send: "Send",
    slippingHelp: "I'm slipping right now",
    craving: "Craving",
    startCraving: "Start a craving session",
    endCraving: "End session",
    victoryToday: "Log a victory",
    reflection: "Night reflection",
    reflectionSub: "Close today with kindness.",
    quietReturn: "Quiet return",
    yourMemories: "Your memories",
    yourConsent: "Your consent",
    safetyTitle: "Safety & support",
    safetySub: "Your circle of support, always one tap away.",
    emergencyContact: "Emergency contact",
    helplines: "Helplines",
    ifCrisis: "If you need immediate support",
    ifCrisisSub: "You are not alone. Reach out — we've kept your circle close.",
    alertNow: "Alert my contact now",
    acknowledgeAlert: "I'm safe right now",
    onboardingTitle: "Let's get you set up",
    onboardingSub: "A few gentle questions so Inner Compass fits you.",
    emotionalGoals: "Emotional goals",
    struggles: "What are you working through?",
    supportPrefs: "How would you like to be supported?",
    sleep: "Sleep schedule",
    workShifts: "Work shifts",
    preferredName: "Preferred name",
  },
  admin: {
    title: "Admin",
    subtitle: "Health of the whole platform.",
    activeUsers: "Active users",
    conversations: "Conversations",
    crises: "Crisis alerts",
    flagged: "Flagged content",
    pendingApprovals: "Pending approvals",
    inviteCode: "Invite code",
    codeUsage: "Usage",
    approveUser: "Approve",
    rejectUser: "Reject",
    revokeUser: "Revoke",
    restoreUser: "Restore",
    feedbackList: "User feedback",
    createInvite: "Create invite",
    createBetaCode: "Create beta code",
    exportCsv: "Export CSV",
    retention: "Retention",
    funnel: "Funnel",
    adoption: "Adoption",
    performance: "Performance",
    errors: "Errors",
    testers: "Testers",
  },
  platform: {
    title: "Business",
    subtitle: "Your organisation at a glance.",
    orgOverview: "Organisation overview",
    seats: "Seats",
    used: "Used",
    available: "Available",
    inviteMember: "Invite member",
    createTeam: "Create team",
    createLocation: "Create location",
    createDepartment: "Create department",
    outbox: "Outbox",
    assignInvite: "Assign invite",
    audit: "Audit log",
    wellbeingAggregate: "Wellbeing (aggregate, anonymised)",
  },
  care: {
    title: "Care",
    subtitle: "Your clients, held gently.",
    clients: "Clients",
    inviteClient: "Invite a client",
    trends: "Trends",
    generateReport: "Generate report",
    weeklyReport: "Weekly report",
    grantConsent: "Grant consent",
    revokeConsent: "Revoke consent",
    dossier: "Dossier",
    alerts: "Crisis alerts",
    noAlerts: "No active alerts — clients are steady today.",
    archiveClient: "Archive client",
  },
  settings: {
    profile: "Profile",
    preferences: "Preferences",
    languagePref: "Preferred language",
    themePref: "Theme",
    account: "Account",
    changePassword: "Change password",
    delete: "Delete account",
    consent: "Consent",
  },
  errors: {
    generic: "Something went wrong.",
    unauthorized: "Your session has ended. Please sign in again.",
    forbidden: "You don't have access to this area.",
    notFound: "We couldn't find that.",
    validation: "Please check the fields and try again.",
  },
  public: {
    nav: {
      privacy: "Privacy",
      terms: "Terms",
      cookies: "Cookies",
      safety: "Safety",
      support: "Support",
      contact: "Contact",
      deleteAccount: "Account deletion",
      aiSafety: "AI & Safety",
      privacyChoices: "Privacy choices",
    },
    footer: {
      legal: "Legal",
      help: "Help",
      company: "Company",
      contact: "Contact",
      rights: "All rights reserved.",
      companyLines: ["Inner Compass", "Dutch sole proprietorship", "KvK 42129904"],
    },
    lastUpdated: "Last updated: 1 October 2026",
    privacy: {
      title: "Privacy Statement",
      meta: "Privacy statement of Inner Compass — which personal data we process, why, with whom it may be shared, how long we keep it and your rights under the GDPR.",
    },
    terms: {
      title: "Terms of Use",
      meta: "Terms of Use of Inner Compass — the rules for using our website, mobile and web applications and other services.",
    },
    cookies: {
      title: "Cookie Policy",
      meta: "Cookie Policy of Inner Compass — how our website and web application use cookies and similar technologies.",
    },
    aiSafety: {
      title: "AI, wellbeing & safety",
      meta: "What Inner Compass is and is not: AI limitations, safety and crisis information.",
    },
    privacyChoices: {
      title: "Your privacy choices",
      meta: "Your privacy rights and how to exercise them when using Inner Compass.",
    },
    safety: {
      title: "Safety & support",
      subtitle: "Inner Compass is a companion, not a crisis line. If you or someone you know is in immediate danger, please reach out to the resources below.",
      crisis: {
        heading: "If you're in crisis right now",
        body: "Please call your local emergency number and stay on the line. You are not alone.",
        eu: "European emergency number: 112",
        nl113: "Netherlands — 113 Zelfmoordpreventie: call 113 or 0800-0113 (free, 24/7)",
        samaritans: "United Kingdom — Samaritans: call 116 123 (free, 24/7)",
      },
      whatwedo: {
        heading: "What Inner Compass offers around safety",
        body: "The app is designed to keep your circle of support one tap away.",
        emergency: "Add an emergency contact so you can send them an SMS in a difficult moment.",
        helplines: "In-app helplines page with country-specific numbers.",
        consent: "Trusted contacts and clinicians only see what you explicitly consented to share.",
      },
      limits: {
        heading: "What Inner Compass is not",
        body: "Inner Compass is not a medical device or replacement for professional care. In an emergency please contact the services above.",
      },
      cta: "Contact support",
    },
    support: {
      title: "Support",
      subtitle: "We're a small team. If you can't find an answer here, write to us at support@innercompass.tech and we'll respond as soon as we can.",
      contact: {
        heading: "Contact us",
        body: "Email us any time — we usually reply within a few working days.",
      },
      card: {
        privacy: { title: "Privacy Policy", body: "How we handle your data, what we collect and your rights under GDPR." },
        terms:   { title: "Terms of Service", body: "The rules for using Inner Compass." },
        delete:  { title: "Delete your account", body: "Permanently remove your Inner Compass account and personal data." },
        safety:  { title: "Safety resources", body: "Helplines and information if you or someone you know needs urgent help." },
      },
    },
    contact: {
      title: "Contact Inner Compass",
      subtitle: "Reach us by email for anything — support, privacy requests, feedback or partnerships.",
      support: { title: "General support", body: "Bug reports, product questions, feature ideas." },
      privacy: { title: "Privacy & data requests", body: "Access, correction, deletion or portability of your data." },
      form: {
        heading: "Or send us a message",
        subject: "Subject",
        message: "Message",
        submit: "Open email app",
        mailto_note: "Submitting opens your email app pre-filled with your message. We do not store form submissions on this page.",
      },
      mail: {
        name: "Name",
        email: "Email",
        subjectDefault: "Message from Inner Compass website",
      },
    },
    delete: {
      eyebrow: "Account deletion",
      title: "Delete your account and data",
      subtitle: "You remain in control of your Inner Compass account and personal data. We verify who you are first, so nobody else can delete your account.",
      intro: "You remain in control of your Inner Compass account and personal data.",
      inApp: {
        heading: "Delete your account",
        body1: "If account deletion is available in the app, you can delete your account via the account settings and follow the on-screen confirmation steps.",
        body2: "If you cannot delete your account from the app or need help, please contact us via support@innercompass.tech or privacy@innercompass.tech. Mention the email address linked to your Inner Compass account.",
        verify: "We may ask you to confirm your identity to prevent someone else from having your account deleted.",
      },
      removed: {
        heading: "What gets deleted?",
        intro: "On final account deletion we remove or anonymise, subject to statutory exceptions, personal data linked to your account, including where applicable:",
        items: [
          "profile data;",
          "check-ins;",
          "mood history;",
          "journal data;",
          "reflections;",
          "AI conversations;",
          "personal memory and context;",
          "recovery plans;",
          "personal strategies;",
          "emergency contacts;",
          "personal settings.",
        ],
      },
      backups: {
        heading: "Backups",
        body1: "After deletion, data may remain temporarily in secured backups until these are deleted or overwritten according to the normal backup cycle.",
        body2: "Data in such backups is not re-used for normal product purposes.",
      },
      legal: {
        heading: "Legal obligations",
        body: "Where Inner Compass is legally required to retain certain limited information, this may be kept for the required period and used solely for the applicable legal purpose.",
      },
      subs: {
        heading: "Subscriptions",
        body1: "Deleting your Inner Compass account may not automatically end a subscription that is managed via the Apple App Store, Google Play or another external payment provider.",
        body2: "Such a subscription must, where necessary, be cancelled separately with the provider in question.",
      },
      helpBlock: {
        heading: "Help",
        emails: ["support@innercompass.tech", "privacy@innercompass.tech"],
      },
      what: {
        heading: "What deletion removes",
        item1: "Your account, profile and login credentials.",
        item2: "Your check-ins, reflections, plans, memories and Companion conversations.",
        item3: "Your consent state and any signals you were sharing with an organisation or clinician.",
        item4: "Personal identifiers in our logs. Some records may be kept as anonymised statistics or retained for a legal minimum period (e.g. invoicing) and are then deleted.",
      },
      orgNote: {
        heading: "If your account is sponsored by an organisation",
        body: "Deleting your personal account does not delete the organisation's account. Data that belongs to other people or to the organisation (invitations you sent, aggregate reports, etc.) remains with them.",
      },
      signin: {
        heading: "Verify your identity",
        body: "We never delete an account based on an unverified email address. Sign in with the account you want to delete, or email the addresses above and we will handle it.",
        cta: "Sign in",
        note: "Trouble signing in?",
      },
      confirm: {
        heading: "Confirm deletion",
        signedInAs: "Signed in as",
        body: "This action is permanent and cannot be undone. Please confirm each item below.",
        ack1: "I understand this will permanently delete my account and all my personal Inner Compass data.",
        ack2: "I understand this action cannot be undone by support.",
        typePrompt: "Type {{word}} to confirm",
        cta: "Delete my account permanently",
      },
      confirmWord: "DELETE",
      done: {
        heading: "Your account has been deleted",
        body: "We've removed your Inner Compass account and personal data. If we can help further, get in touch.",
        home: "Back to home",
      },
      cancelled: "Deletion cancelled.",
      help: "Need help? Email",
      error: {
        invalid: "Those details didn't match. Please try again.",
        tooMany: "Too many attempts. Please try again later or email support.",
        locked: "For your safety we've paused sign-in from this device for a few minutes.",
        deleteFailed: "We couldn't complete the deletion. Please try again or email support.",
      },
    },
  },
  download: {
    eyebrow: "Inner Compass for Android",
    title: "Get the most out of Inner Compass",
    body: "Inner Compass works best in the app. Take your conversations, check-ins and personal insights with you wherever you go.",
    android: "Download for Android",
    continue: "Continue on website",
    iosSoon: "iOS — coming soon",
    scan: "Scan with your Android phone to open Google Play.",
    scanTitle: "Scan to download",
    more: "More about the app",
    noAccount: "Free to download. No invitation or account needed to install — you decide when to sign in.",
    p1: "Your companion conversations, always with you.",
    p2: "Quick daily check-ins and reminders.",
    p3: "Personal insights and rhythms over time.",
    p4: "Private by design — your data stays yours.",
    nav: "App",
  },
  b2b: b2bEn,
};

export default en;
